const Person = require('../persons')
const connectionStatus = require('./connection-status')

class Agent extends Person {
  constructor(document) {
    super(document)
    this.active = document.active || false
    this.connectionStatus = typeof document.connectionStatus === 'undefined' ? connectionStatus.offline : document.connectionStatus
    this.connectionStatusManual = document.connectionStatusManual || false
    this.lastService = document.lastService || new Date(-8640000000000000)
  }
}

module.exports = Agent
